import type { WpMenuItem } from '~/composables/use-wp/api/menu-items';

export const useMenuStore = defineStore('menus', {
  state: () => ({
    headerNav: [] as WpMenuItem[],
    headerTopNav: [] as WpMenuItem[],
    socialLinks: [] as WpMenuItem[],
    footerNav: [] as WpMenuItem[],
    navsFetched: false
  }),

  getters: {
  },

  actions: {
    async fetchAll() {
      if (this.navsFetched) {
        return;
      }

      const wp = useWp();
      const runtimeConfig = useRuntimeConfig();

      const [
        headerNav,
        headerTopNav,
        socialLinks,
        footerNav
      ] = await Promise.all([
        wp.menuItems.getBySlug('header'),
        runtimeConfig.public.phase === 'vote'
          ? wp.menuItems.getBySlug('header-top')
          : Promise.resolve([]),
        wp.menuItems.getBySlug('social-links'),
        wp.menuItems.getBySlug('footer')
      ]);

      this.headerNav = headerNav;
      this.headerTopNav = headerTopNav;
      this.socialLinks = socialLinks;
      this.footerNav = footerNav;
      this.navsFetched = true;
    }
  }
});
